export default {
  setInitialState(state, payload) {
    state.base.peiId = payload.peiId;
    state.base.peiGgradeId = payload.peiGgradeId;
    state.base.studentSieId = payload.studentSieId;
    state.base.academicYearId = payload.academicYearId;
    state.base.programServiceAreaId = payload.programServiceAreaId;
    state.selectedArea = { ...payload.selectedArea };
  },
  setSysParameters(state, payload) {
    state.sysParameters = { ...payload };
  },
  setResources(state, payload) {
    state.resources = { ...payload };
  },
  setNecessityCatalogue(state, payload) {
    state.catalogueOptions.necessities = [...payload];
  },
  setAdequacyCatalogue(state, payload) {
    state.catalogueOptions.adequacy = [...payload];
  },
  setGradeCatalogue(state, payload) {
    state.catalogueOptions.grades = [...payload];
  },
  setTermsCatalogue(state, payload) {
    state.catalogueOptions.terms = [...payload];
  },
  setSuitabilitiesCatalogue(state, payload) {
    state.catalogueOptions.suitabilities = [...payload];
  },
  setInstrumentsCatalogue(state, payload) {
    state.catalogueOptions.instruments = [...payload];
  },
  setAvailableProceduresCatalogue(state, payload) {
    state.catalogueOptions.availableProcedures = [...payload];
  },
  setNecessities(state, payload) {
    state.selectedNecessities = [...payload];
  },
  setStrengthNecessitySelection(state, payload) {
    state.selectedStrengthsNecessities = [...payload];
  },
  setGoals(state, payload) {
    state.createdGoals = [...payload];
  },
  setSkillCatalogue(state, payload) {
    state.catalogueOptions.skills = [...payload];
  },
  setStrengthsCatalogue(state, payload) {
    state.catalogueOptions.availableStrengths = [...payload];
  },
  setSubAreasCatalogue(state, payload) {
    state.catalogueOptions.subAreas = [...payload];
  },
  setProceduresSelection(state, payload) {
    state.selectedProcedures = [...payload];
  },
  setStrengthsSelection(state, payload) {
    state.selectedStrengths = [...payload];
  },
  setSubAreaSelection(state, payload) {
    state.selectedSubAreas = [...payload];
  }
};
